// 请写下当前页面备注
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import { Input, Pagination, Drawer, theme, Space, Button, Form, Card, App, InputNumber, Tree, Switch, Spin, Empty, Tooltip } from 'antd';
import { ArrowLeftOutlined, QuestionCircleOutlined, SettingOutlined, BlockOutlined, WarningOutlined, PlusOutlined } from '@ant-design/icons'
import ImageCom from "@/component/ImageCom/index.js"//图片显示组件

import { getRiskSetListAPI, getRiskSwitchInfoFun, setRiskSwitchInfoFun, submitPictureApi } from '@/server/fixedPoint/list.js'
import ShowImgs from './showImg.js'
import { debounce } from '@/common/js/common.js'
import './index.css'

function RiskSet (props) {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const params = location.state;
  const {
    token: { colorText, colorPrimary, colorErrorText, colorBgElevated },
  } = theme.useToken(); //获取主题颜色
  const { message } = App.useApp();
  const [similarityForm] = Form.useForm();//相似度
  const [form] = Form.useForm();//航点名称

  const token = localStorage.getItem('dock_token');
  const [loading, setLoading] = useState(false)//加载中···
  const [pictureData, setPictureData] = useState([]) //获取的数据

  // 上传图片相关-------------------------
  const inputRef = useRef();
  const curIDRef = useRef();
  const curRIDRef = useRef();
  const currIdxRef = useRef();
  // 上传图片相关-------------------------



  // 查看图片相关-----------------------------

  const [curSeeImg, setCurSeeImg] = useState({//当前需要查看的图片列表信息
    open: false,//图片查看  是否打开
    type: -1,//当前需要查看的图片类型   1：缩略图   2：原图
    curClickIdx: -1,//当前点击的图片下标
    isLiftPage: true,//当前是否有上一张图片
    isRightPage: true,//当前是否有下一张图片
  })

  const searchPage = useRef(1)//当前选中的页码
  const isNextPage = useRef(false)//是否还有下一页
  const curSeeImgOpenRef = useRef(false)//是否打开图片查看组件
  const curClickIdxRef = useRef(-1)//当前点击图片下标
  const [imgsLoading, setImgsLoading] = useState(false)//加载中···
  const [imgArr, setImgArr] = useState([])//图片集合

  // 查看图片相关-----------------------------



  //异常类型
  const [treeData, setTreeData] = useState([]);
  const [abnormalType, setAbnormalType] = useState([]);//异常框选列表
  const [expandedKeys, setExpandedKeys] = useState([]);//展开的父节点

  const [imgWidth, setImgWidth] = useState(0);//图片宽度

  const [similarityList, setSimilarityList] = useState({//相似度设置
    isOpen: false,
    title: '相似度',
    id: params.list.id,//当前id
    similarity: '',//相似度
  })
  const [similarityLoading, setSimilarityLoading] = useState(false);//加载

  const [riskInfo, setRiskInfo] = useState({ //风险信息
    isOpen: false,
    id: '',
  });
  const [riskLoading, setRiskLoading] = useState(false);//加载

  const [searchList, setSearchList] = useState({//搜索列表
    check: 0,
    type: -1,
    page: 1,
    total: 0,
    perpage: 12,
    similarity: 0,
  })

  const getListData = async (data) => {//获取图片列表
    setLoading(true)
    let sea = searchList
    let obj = {
      access_token: token,
      id: params.list.id,
      page: data.page,
      perpage: data.perpage,
    }

    let res = await getRiskSetListAPI(obj)
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      setLoading(false)
      return;
    }
    sea.total = res.data.list.total
    sea.similarity = res.data.threshold
    setSearchList({ ...sea })

    let img = []
    let arr = res.data?.list?.items.map((res, index) => {
      img.push(res.pic)
      return { ...res, isDeletion: false, idx: index }
    })
    setImgArr([...img])
    setPictureData([...arr])
    let similarity = { ...similarityList };
    similarity.similarity = parseInt(res.data.threshold * 100);
    setSimilarityList(similarity);
    setLoading(false)
  }

  //获取风险开关信息
  const getRiskSwitchInfo = async (id) => {
    setRiskLoading(true);
    let res = await getRiskSwitchInfoFun({
      access_token: token,
      id: id
    });
    if (res.ret !== 200) {
      setRiskLoading(false);
      message.warning(res.msg || '数据跑丢了~');
      return;
    }
    let choose = res.data.data.risk_cid ? res.data.data.risk_cid.split(',') : [];
    let expanded = []; //父级 展开
    let items = [];//树
    for (let i = 0; i < res.data.risk_cid.length; i++) {
      let val = res.data.risk_cid[i];
      let idx = expanded.indexOf('r-' + val.risk_id);
      if (idx < 0) { //不存在
        idx = expanded.length;
        expanded.push('r-' + val.risk_id);
        items.push({
          title: val.risk_name,
          key: 'r-' + val.risk_id,
          checkable: false,
          children: [
            {
              checkable: false,
              title: val.name, key: Number(val.risk_cid), parentKey: Number(val.risk_id),
              parentIdx: idx, idx: 0, checked: choose.indexOf(val.risk_cid.toString()) >= 0 ? true : false
            }
          ],
        })
      } else {//存在
        items[idx].children.push({
          checkable: false,
          title: val.name, key: Number(val.risk_cid), parentKey: Number(val.risk_id),
          parentIdx: idx, idx: items[idx].children.length, checked: choose.indexOf(val.risk_cid.toString()) >= 0 ? true : false
        });
      }
    }
    setTreeData(items);
    setAbnormalType(res.data);
    setExpandedKeys(expanded);
    setRiskLoading(false);
  }

  const submitSimilarityListForm = async (a, b) => { //提交相似度
    let info = { ...similarityList };
    let params = {
      access_token: token,
      RID: info.id,
      threshold: (similarityList.similarity / 100).toFixed(2)
    }
    setSimilarityLoading(true);
    let res = await setRiskSwitchInfoFun(params);
    setSimilarityLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      return;
    }
    message.success('编辑成功');
    let sea = { ...searchList };
    sea.similarity = params.threshold;
    setSearchList(sea);
    info.isOpen = false;
    setSimilarityList(info);
  }

  //获取图片父级宽度 以及 对应图片宽度
  const getImgFatherWidth = () => {
    setTimeout(() => {
      let dom = document.getElementById('imgFather');
      let width = dom.clientWidth;
      setImgWidth(Number((width * 0.24).toFixed(2)));
    }, 200);
  }

  //航点名称 提交
  const submit = async (e) => {
    let info = { ...riskInfo };
    let arr = [];
    for (let i = 0; i < treeData.length; i++) {
      for (let n = 0; n < treeData[i].children.length; n++) {
        let val = treeData[i].children[n]
        if (val.checked) {
          arr.push(val.key);
        }
      }
    }
    let params = {
      access_token: token,
      id: info.id,
      risk_cid: arr.join(','),
      name: e.name
    };
    setRiskLoading(true);
    let res = await setRiskSwitchInfoFun(params);
    setRiskLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      return;
    }

    let pic = pictureData
    pic.find(res => res.id === info.id).name = e.name
    setPictureData([...pic])

    info.isOpen = false;
    info.id = '';
    setRiskInfo(info)
    message.success('编辑成功');
    // getListData(searchList);
  }

  //上传图片
  const submitPicture = async (file) => {
    let key = 'submitImg'
    message.loading({
      content: '上传中...',
      key,
    });
    let res = await submitPictureApi({
      access_token: token,
      id: curIDRef.current,
      RID: curRIDRef.current,
      file: file
    });
    inputRef.current.value = '';
    if (res.ret !== 200) {
      message.warning({
        content: res.msg || '数据跑丢了~',
        key,
      });
      return;
    }
    message.loading({
      content: '上传成功',
      key,
    });
    let pic = pictureData
    pic.find(res => res.id === curIDRef.current).pic = res.data || 'xxxxxxxxxxxxx'
    pic.find(res => res.id === curIDRef.current).handler_status = 0
    setPictureData([...pic])
  }

  useEffect(() => {
    getListData(searchList);
    getImgFatherWidth();
    window.addEventListener("keydown", onkeydown);
    window.addEventListener('resize', getImgFatherWidth);
    return () => {
      window.removeEventListener('keydown', onkeydown); // 销毁
      window.addEventListener('resize', getImgFatherWidth);
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div id='main_div' className="disFlex flexDirCol posRel tablebackcol" style={{ height: '100%', overflow: 'auto', color: colorText }}>
      {/* 头部 */}
      <div className="flex jcsb marTB16  marRL24 align_center">
        <div className='flex jcl align_center'>
          {/* 返回按钮 */}
          <span onClick={() => { navigate(-1) }} className='curPointer'><ArrowLeftOutlined /> </span>
          {/* 航线名称 */}
          <span className='fSize20 fWei500 margR12 margL18'>{params.list.title}</span>
        </div>
        {/* 相似度 */}
        <div className='flex jcr  align_center'>
          <span className='marR8'>识别相似度：{searchList.similarity}</span>
          <SettingOutlined
            className='pointer'
            style={{ width: '16px', height: '16px', color: colorPrimary }}
            onClick={() => {
              let sim = similarityList
              sim.isOpen = true
              setSimilarityList({ ...sim })
            }}
          />
        </div>
      </div>

      <Card
        className='marRL24'
        style={{ border: 0 }}
      >
        <Spin spinning={loading}>
          <div className={"flex flex_wrap " + (pictureData && pictureData.length > 0 ? '' : 'justify_center')} id='imgFather' style={{ flexDirection: 'row', maxHeight: '100%', overflowY: 'auto', alignContent: 'flex-start' }}>
            {
              pictureData && pictureData.length > 0 ? pictureData.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{ width: '24%', height: 'auto', marginBottom: '24px', marginRight: '1%' }}
                    className='flex_col pos_rel'

                  >
                    <div
                      className={`${item.isDeletion ? '' : 'pointer'}`}
                      onClick={() => {
                        if (!item.isDeletion) {
                          let allImgs = imgArr.length
                          let cur = curSeeImg
                          cur.type = 1
                          cur.open = true
                          curSeeImgOpenRef.current = true
                          cur.curClickIdx = item.idx
                          curClickIdxRef.current = item.idx
                          cur.isLiftPage = (searchPage.current > 1 || (searchPage.current === 1 && item.idx !== 0))
                          cur.isRightPage = (isNextPage.current || cur.curClickIdx < (allImgs - 1))
                          setCurSeeImg({ ...cur })
                        }
                      }}
                    >
                      {/* 图片 */}
                      <ImageCom
                        alt='index'
                        height={Number((imgWidth * 3 / 4).toFixed(2))}
                        borderRadius={8}
                        src={item.pic}
                        errorBackground='#000000'
                        deletion={(e) => {
                          let pic = pictureData
                          pic.find(res => res.id === item.id).isDeletion = e
                          setPictureData([...pic])
                        }}
                      />
                    </div>


                    <div className='marT4 flex_row justify_between align_center'>
                      {/* 航线名称 */}
                      <div>{`${item.order}# ${item.name ? item.name : item.routesname ? item.routesname : item.porder}`} </div>
                      <div>
                        <Space>
                          <>
                            <Tooltip
                              title={
                                <div className='flex_col'>
                                  <div>{item.ptitle ? item.ptitle : <div className='opa25'>-</div>}</div>{/* 航线名称 */}
                                  <div>{item.porder ? item.porder : <div className='opa25'>-</div>}</div>{/* 航点序号 */}
                                  <div>{item.routesname ? item.routesname : <div className='opa25'>-</div>}</div>{/* 原航点名称 */}
                                </div>
                              }
                            >
                              <BlockOutlined className='pointer' style={{ color: '#1668DC' }} />
                            </Tooltip>
                          </>

                          {
                            item.isDeletion &&
                            <PlusOutlined
                              className='pointer'
                              style={{ width: '16px', height: '16px', color: '#1668DC' }}
                              onClick={() => {
                                curIDRef.current = item.id
                                curRIDRef.current = item.RID
                                currIdxRef.current = item.index
                                inputRef.current.click();
                              }}
                            />
                          }

                          <SettingOutlined
                            className='pointer'
                            style={{ width: '16px', height: '16px', color: colorPrimary }}
                            onClick={() => {
                              let info = { ...riskInfo };
                              info.isOpen = true;
                              info.id = item.id;
                              setRiskInfo(info);
                              form.setFieldsValue({
                                name: item.name
                              });
                              // getRiskOptions(item.type);
                              getRiskSwitchInfo(item.id);
                            }}
                          />
                        </Space>

                      </div>
                    </div>
                  </div>
                )
              }) :
                <div>
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            }
          </div>

          <div className='disFlex jusConEnd'>
            <Pagination
              align='end'
              total={searchList.total}
              current={searchList.page}
              pageSize={searchList.perpage}
              pageSizeOptions={['12', '24', '48', '96']}
              showTotal={(total) => `共 ${total} 条数据 `}
              onChange={(page, pageSize) => {
                let sea = searchList
                sea.page = page;
                sea.perpage = pageSize;
                setSearchList({ ...sea })
                getListData(sea);
              }}
            />
          </div>
        </Spin>


      </Card>


      {/* 相似度 */}
      <Drawer title="相似度" width={256} destroyOnClose={true} open={similarityList.isOpen}
        onClose={() => {
          let sim = similarityList
          sim.isOpen = false
          setSimilarityList({ ...sim })
        }}
        extra={
          <Space>
            <Button
              type="primary"
              loading={similarityLoading}
              onClick={submitSimilarityListForm}
            >
              提交
            </Button>
          </Space>
        }
      >

        <Form layout='vertical' form={similarityForm} >
          <Form.Item
            label={`识别-相似度`}
            tooltip={{
              title: 'AI识别风险时，相似度大于该值才会报警，范围30~100',
              icon: <QuestionCircleOutlined />,
              placement: 'left',
            }}
          >
            <InputNumber
              value={similarityList.similarity}
              addonAfter="%"
              placeholder='-'
              min='30'
              max='100'
              className='wid100'
              onChange={(e) => {
                let sim = similarityList
                if (e > 0) {
                  sim.similarity = e
                } else {
                  sim.similarity = null
                }
                setSimilarityList({ ...sim })
              }}
            />
          </Form.Item>
        </Form>

      </Drawer>

      {/* 航点名称 */}
      <Drawer title="航点名称" width={256} destroyOnClose={true} open={riskInfo.isOpen}
        afterOpenChange={() => {
          document.getElementsByClassName('ant-tree')[0].style.background = colorBgElevated;
        }}
        onClose={() => {
          let info = { ...riskInfo };
          info.isOpen = false;
          info.id = '';
          setRiskInfo(info);
        }}
        extra={
          <Space>
            <Button
              type="primary"
              loading={riskLoading}
              onClick={() => {
                form.submit()
              }}
            >
              提交
            </Button>
          </Space>
        }
      >
        <div id='risk_set' className='flex_col'>
          <Form layout='vertical' form={form} onFinish={submit}>
            <Form.Item label='航点名称' name='name' rules={[
              {
                required: true,
                message: '航点名称不能为空',
              },
            ]} >
              <Input placeholder='-' />
            </Form.Item>
          </Form>

          <div className='flex_auto' style={{ overflow: 'auto' }}>
            <Tree
              showLine={{ showLeafIcon: <div style={{ color: colorErrorText }}><WarningOutlined /></div> }}
              blockNode
              expandedKeys={expandedKeys}
              // showIcon={true}
              autoExpandParent={true}
              defaultExpandAll='true'
              defaultExpandParent={true}
              onSelect={() => { }}
              onExpand={(keys) => {
                setExpandedKeys(keys);
              }}
              titleRender={(item) => {
                let key = item.key.toString();
                if (key.indexOf('r') >= 0) {// 父节点
                  return <span>{item.title}</span>
                }
                return <div className='flex_row justify_between align_center'>
                  <div className='flex_auto marR4' style={{ width: 0 }}>
                    <div className='text_omitted1 col_error_text'>{item.title}</div>
                  </div>
                  <div className='flex_shrink0'>
                    <Switch size="small" checked={item.checked} onChange={(val) => {
                      let arr = [...treeData];
                      arr[item.parentIdx].children[item.idx].checked = val;
                      setTreeData(arr);
                    }} />
                  </div>
                </div>
              }}
              treeData={treeData}
            />
          </div>
        </div>

      </Drawer>


      <>{/* 上传 缺失的图片 */}
        <div style={{ display: 'none' }}>
          <input ref={inputRef} type='file' accept="image/png, image/jpeg" onChange={(e) => {

            let file = e.target.files[0];
            if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
              inputRef.current.value = '';
              return message.error('只能上传jpeg/png格式的图片');
            }
            if (file.size > 50 * 1024 * 1024) {
              inputRef.current.value = '';
              return message.error('图片不能超过50M');
            }
            submitPicture(file);
          }} />
        </div>
      </>


      <>{/* 图片查看组件 */}
        <ShowImgs
          arrData={pictureData}
          picData={imgArr}
          imgIdx={curSeeImg.curClickIdx}
          open={curSeeImg.open}
          loading={imgsLoading}
          imgBackChange={async (e) => {
            console.log('imgBackChange', e)
          }}
          pageChange={debounce((e) => {//上一页、下一页回调
            let cur = curSeeImg
            let sea = searchList
            let allImgs = imgArr.length
            if (e < 0 || e > (allImgs - 1)) {

              if (e < 0 && searchPage.current > 1) {//加载上一页
                cur.curClickIdx = -1
                curClickIdxRef.current = -1
                sea.page -= 1
                searchPage.current -= 1
                setImgsLoading(true)
                getImgsData(sea.check, sea, 'ArrowLeft')
              }

              if (e > (allImgs - 1) && isNextPage.current) {//加载下一页
                cur.curClickIdx = -1
                curClickIdxRef.current = -1
                sea.page += 1
                searchPage.current += 1
                setImgsLoading(true)
                getImgsData(sea.check, sea, 'ArrowRight')
              }
            } else {
              cur.curClickIdx = e
              curClickIdxRef.current = e
              cur.isLiftPage = (cur.curClickIdx !== 0 || sea.page > 1)
              cur.isRightPage = (isNextPage.current || cur.curClickIdx < (allImgs - 1))
            }
            setSearchList({ ...sea })
            setCurSeeImg({ ...cur })
          }, 500)}
          closeChange={(vis) => {
            let cur = curSeeImg; cur.open = vis; curSeeImgOpenRef.current = vis; setCurSeeImg({ ...cur })
          }}
          isLiftPage={curSeeImg.isLiftPage}
          isRightPage={curSeeImg.isRightPage}
        />
      </>


    </div>
  )
}
export default RiskSet;